import { CartLinesUpdateEvent } from '@shopify/events';

/*
 * Botao "Add to my order" do upsell do carrinho (snippets/hv-cart-upsell.liquid).
 * Faz o mesmo caminho do botao de compra do tema: dispara CartLinesUpdateEvent e resolve a
 * promessa com as secoes renderizadas, entao o carrinho lateral se redesenha sozinho (a oferta
 * adicionada vira linha do carrinho e some da lista) e o contador do cabecalho atualiza.
 * O clique e delegado no document porque o carrinho e trocado inteiro a cada atualizacao.
 */

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-hv-upsell-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;

  event.preventDefault();
  button.setAttribute('aria-busy', 'true');

  const variantId = button.dataset.hvUpsellAdd;
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const added = await response.json();
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
      r.json()
    );
    const didError = Boolean(added.status);

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        itemCount: 1,
        sections: didError ? undefined : added.sections,
        source: 'hv-cart-upsell',
        didError,
      },
    });

    if (didError) {
      console.warn('[hv-cart-upsell]', added.description || added.message);
      button.removeAttribute('aria-busy');
    }
  } catch (error) {
    deferred.reject(error);
    button.removeAttribute('aria-busy');
  }
});
